module.exports = __webpack_public_path__ + "static/img/btn_wallpaper004.8c73db8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_wallpaper004.svg
// module id = 84
// module chunks = 0